import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgWizardService} from 'ng-wizard';
import {ActivatedRoute, Params} from '@angular/router';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {SearchRequestService} from '../../../../shared/service/search-request.service';
import {SearchRequestModel} from '../../../../shared/dto/search-request.model';

@Component({
  selector: 'app-request-search-history',
  templateUrl: './request-search-history.component.html',
  styleUrls: ['./request-search-history.component.scss']
})
export class RequestSearchHistoryComponent implements OnInit {
  historyForm: FormGroup;
  requestId: number;
  name: string;
  address: string;
  applicantType: string;
  cdcNo: string;
  cdcDate: Date;
  expiryDate: Date;
  nic: string;
  email:string;
  cocNo: string;
  mobile: string;
  passport: string;
  dob: string;
  nationality: string;
  biometric: string;
  appSts: string;
  public showLable1 :boolean = false;
  public  showLable2:boolean =  false;
  public isBlacklisted: boolean = false;
  public isSuspend: boolean = false;

  constructor(private route: ActivatedRoute,
              private modalService: NgbModal,
              private ngWizardService: NgWizardService,
              private spinnerService: NgxUiLoaderService,
              private requestSearchService: SearchRequestService) { }

  ngOnInit() {
    this.historyForm = new FormGroup({
      name: new FormControl(''),
      address: new FormControl(''),
      applicantType: new FormControl(''),
      cdcNo: new FormControl(''),
      cdcDate: new FormControl(''),
      expiryDate: new FormControl(''),
      nic: new FormControl(''),
      email: new FormControl(''),
      cocNo: new FormControl(''),
      mobile: new FormControl(''),
      passport: new FormControl(''),
      dob: new FormControl(null),
      nationality: new FormControl(null),
      biometric: new FormControl(null),
      appSts:new FormControl(null),
    });

    this.onGetIdFromUrl();
    this.loadRequestData();
  }

  onGetIdFromUrl() {
    this.route.params.subscribe(
      (param: Params) => {
        this.requestId = param.requestId;
      }
    );
  }

  loadRequestData() {
    this.requestSearchService.getByApplicantRequestId(this.requestId).subscribe(
      (data: SearchRequestModel) => {
        if(data.cdcAvailable === "1") {
          this.showLable1 = true;
        }
        if(data.cdcAvailable === "0") {
          this.showLable2 = true;
        }
        if(data.blacklist) {
          this.isBlacklisted = true;
        }
        if(data.suspend) {
          this.isSuspend = true;
        }
        this.historyForm.patchValue(
          {
            name: data.name,
            address: data.address,
            applicantType: data.applicantType,
            cdcNo: data.cdcNo,
            cdcDate: data.cdcIssueDate,
            expiryDate: data.cdcExpiryDate,
            nic: data.nic,
            email: data.email,
            cocNo: data.cocNo,
            mobile: data.mobileNo,
            passport: data.passport,
            dob: data.dateOfBirth,
            nationality: data.nationality,
            biometric: data.biometric,
            appSts: data.appSts,
          }
        );
      }
    )
  }

}
